module.exports = __webpack_public_path__ + "img/other.393d2031.webp";